module.exports = __webpack_public_path__ + "img/ruya.fa4f921b.jpg";